<template>
<div class="my-body py-20 text-white flex flex-wrap md:pt-0 items-center ">
    <div class="w-full md:w-1/2">
        <img :src="aboutImage" />
    </div>
    <div class="w-full md:w-1/2">
        <div>
            <p class="text-2xl main-text md:text-3xl xl:text-4xl font-semibold md:font-bold  ml-4">
                <span>About Us </span><br />
            </p>
            <p class="mx-4 my-8 w-full text-grey md:w-1/2">
                {{settings.about_us}}
            </p>
        </div>
    </div>
</div>
</template>

<script>
import SettingsMixin from "@/mixins/SettingsMixin"
export default {
    mixins: [SettingsMixin],
    data() {
        return {};
    },

    computed: {

        aboutImage() {
            let about_image = "https://edclearn-images.nyc3.cdn.digitaloceanspaces.com/home-screen/about.jpg";
            if (about_image.includes('edc-lms')) {
                let replacement = "https://media.edclearn.com";
                if (this.hasBypass) {
                    replacement = "https://media.main.edclearn.com";
                }
                return about_image.replace('https://edc-lms.s3-eu-west-1.amazonaws.com', replacement)
            } else {
                return about_image;
            }
        }
    }

};
</script>

<style lang="scss" scoped>
.my-body {
    background: #f5fbff;
}

.main-text {
    color: color(lms-tenant);
}

.text-grey {
    color: #5c5c5c;
}

.negative-top {
    margin-top: -0.5em;
}
</style>
